import { render, staticRenderFns } from "./UpstreamStatistics.vue?vue&type=template&id=41071e07&"
import script from "./UpstreamStatistics.vue?vue&type=script&lang=js&"
export * from "./UpstreamStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports